import {
  array,
  ArraySchema,
  boolean,
  BooleanSchema,
  date,
  DateSchema,
  mixed,
  number,
  NumberSchema,
  object,
  ObjectSchema,
  string,
  StringSchema
} from 'yup';
import { Props } from './DynamicForm';
import { DFData, DField, DFormArrayField } from './types';

const schemaConstructors = {
  mixed: mixed(),
  string: string(),
  number: number(),
  boolean: boolean(),
  date: date(),
  array: array(),
  object: object()
};

type SchemaType =
  | StringSchema
  | NumberSchema
  | BooleanSchema
  | DateSchema
  | ArraySchema<{}>
  | ObjectSchema<{}>;

interface FieldSchema {
  [fieldName: string]: SchemaType;
}

export const validationSchema = (props: Props) => {
  return props.yupSchema ? props.yupSchema : objectSchema(props.data);
};

const objectSchema = (data: DFData) => {
  return object().shape(
    data.fields.reduce((acc: FieldSchema, field: DField) => {
      const schema = fieldSchema(field);
      return schema
        ? {
            ...acc,
            [field.name]: schema
          }
        : { ...acc };
    }, {})
  );
};

const fieldSchema = (field: DField): SchemaType | null => {
  if (
    field.validationRules &&
    field.validationRules.rules &&
    field.validationRules.rules.length
  ) {
    let schemaConstructor = schemaConstructors[
      field.validationRules.type
    ].label(field.label || field.name);

    schemaConstructor = field.validationRules.rules.reduce((acc, rule) => {
      const args = [rule.value, rule.message].filter(arg => arg !== undefined);
      //@ts-ignore
      return acc[rule.name](...args);
    }, schemaConstructor);

    return field.type === 'array'
      ? (schemaConstructor as ArraySchema<{}>).of(
          objectSchema((field as DFormArrayField).data)
        )
      : schemaConstructor;
  } else {
    return null;
  }
};
